<template>
  <div>
    <div class="tek">
      <div class="profilePicture" style="opacity: 0"></div>
      <span class="label small">Naam</span>
      <span class="label large">Email</span>
      <span class="label small">Telefoon</span>
      <span class="label small">Disciplines</span>
      <!-- <div class="label small"><span v-for="(t, i) in tek.userProfile.disciplines" :key="i">{{t[0]}}</span></div> -->
      <span class="label medium">Bedrijfsnaam</span>
      <span class="label medium">Woonplaats</span>
      <span class="label small">Tekenprogramma's</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ListItemHeader',
  }
</script>

<style lang="sass" scoped>

.tek
  margin: 0 auto
  display: flex
  width: fit-content
  align-items: center
  background-color: #e4ecfa
  border: 1px solid rgba(0, 0, 0, 0.05)
  color: black
  font-weight: 500
  padding: 14px
  overflow-x: hidden
  
  > *
    white-space: nowrap
    margin-right: 15px
    min-width: 180px
    // width: 10%

  .label
    overflow-x: hidden
    &.small
      $size: 150px
      min-width: $size
      max-width: $size
    &.medium
      $size: 220px
      min-width: $size
      max-width: $size
    &.large
      $size: 240px
      min-width: $size
      max-width: $size



span
  white-space: nowrap
  overflow-x: hidden
  font-size: 15px
  
.profilePicture
  $size: 32px
  min-width: $size
  max-width: $size
  min-height: $size
  max-height: $size
  border-radius: 100%
  background-color: rgba(0, 0, 0, 0.05)
  background-size: cover
  background-position: center
</style>